// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"c7b33065","214":"79a72d7d","652":"361a3219"}[chunkId] + ".chunk.js";
};